export const listStyle = 'm-0 p-0 list-none flex flex-col gap-y-2'
